import { LEGAL_LINKS } from './legalLinks';

/** Firestore: public read; admin/superuser write. */
export const PUBLIC_SITE_CONTENT_COLLECTION = 'publicSiteContent';
export const LOGIN_PAGE_DOC_ID = 'login';

/**
 * Marketing-aligned two-part footer (handoff 20 §A / §D): company/registration
 * left, legal links right. Shared by the signed-in app shell and the login page
 * so both match the marketing site footer (Marcus 2026-07-06).
 */
export const DEFAULT_MARKETING_FOOTER_INNER_HTML = `
<span class="af-company">© 2025-2026 Ecological Intelligence Ltd · Registered in England and Wales · Company No. 16866497 · VAT GB506945280 · ICO ZC144577 · Registered Office: Brimbles, Ashburton, Newton Abbot, TQ13 7HU</span>
<nav class="af-legal" aria-label="Legal">
  <a href="${LEGAL_LINKS.terms}" target="_blank" rel="noopener noreferrer">Terms</a><span class="af-sep">·</span>
  <a href="${LEGAL_LINKS.privacy}" target="_blank" rel="noopener noreferrer">Privacy</a><span class="af-sep">·</span>
  <a href="${LEGAL_LINKS.dpa}" target="_blank" rel="noopener noreferrer">DPA</a><span class="af-sep">·</span>
  <a href="${LEGAL_LINKS.trust}" target="_blank" rel="noopener noreferrer">Trust</a><span class="af-sep">·</span>
  <a href="${LEGAL_LINKS.cookies}" target="_blank" rel="noopener noreferrer">Cookies</a><span class="af-sep">·</span>
  <a href="${LEGAL_LINKS.disclaimer}" target="_blank" rel="noopener noreferrer">Disclaimer</a>
</nav>
`.trim();

/** @deprecated Prefer DEFAULT_MARKETING_FOOTER_INNER_HTML — kept as the login default alias. */
export const DEFAULT_LOGIN_FOOTER_INNER_HTML = DEFAULT_MARKETING_FOOTER_INNER_HTML;

/**
 * Default HTML shown above the footer (login/register). Use empty string in Firestore to hide.
 * If the field is missing, this default is used.
 *
 * Default is now empty so the login/register pages show no notice block unless
 * an admin explicitly sets `noticeHtml` on the `publicSiteContent/login` doc.
 * (The previous "For new account enquiries please write to accounts@ecointel.io"
 * default was removed per product request.)
 */
export const DEFAULT_LOGIN_NOTICE_HTML = '';

export function resolveLoginFooterHtml(data) {
  if (data == null || data.footerHtml == null) return DEFAULT_LOGIN_FOOTER_INNER_HTML;
  const t = String(data.footerHtml).trim();
  if (!t) return DEFAULT_LOGIN_FOOTER_INNER_HTML;
  return data.footerHtml;
}

/** Missing field → default; explicit empty string → no notice block. */
export function resolveLoginNoticeHtml(data) {
  if (data == null || data.noticeHtml == null) return DEFAULT_LOGIN_NOTICE_HTML;
  return data.noticeHtml;
}

/**
 * Signed-in app shell footer (handoff 20 §A). Same two-part marketing markup as
 * the login footer. Stored on `publicSiteContent/login` as `appLayoutFooterHtml`.
 */
export const DEFAULT_APP_LAYOUT_FOOTER_HTML = DEFAULT_MARKETING_FOOTER_INNER_HTML;

export function resolveAppLayoutFooterHtml(data) {
  if (data == null || data.appLayoutFooterHtml == null) return DEFAULT_APP_LAYOUT_FOOTER_HTML;
  const t = String(data.appLayoutFooterHtml).trim();
  if (!t) return DEFAULT_APP_LAYOUT_FOOTER_HTML;
  return data.appLayoutFooterHtml;
}
